const mergeResumoIntegracao = (fromApi, fromRow) => {
  if (!fromApi && !fromRow) return undefined;
  if (!fromApi) return fromRow;
  if (!fromRow) return fromApi;
  return { ...fromApi, ...fromRow };
};

export const mergeNsmpResumoIntoRow = (row, resumo) => {
  if (!row || !resumo) return row;
  return {
    ...row,
    totalEventos: resumo.totalEventos ?? row.totalEventos,
    eventosResumo: resumo.eventosResumo ?? row.eventosResumo,
    minhaDigitacao: resumo.minhaDigitacao ?? row.minhaDigitacao,
    resumoDigitacao: resumo.resumoDigitacao ?? row.resumoDigitacao,
    resumoIntegracao: mergeResumoIntegracao(resumo.resumoIntegracao, row.resumoIntegracao),
  };
};

export const mergeNsmpResumos = (nsmps, nsmpResumos) => {
  if (!nsmpResumos?.length) return nsmps || [];
  const byId = new Map(nsmpResumos.map((item) => [item.id, item]));
  return (nsmps || []).map((row) => mergeNsmpResumoIntoRow(row, byId.get(row.id)));
};

export const mergeNsmpResumosArrays = (base = [], extra = []) => {
  const byId = new Map((base || []).map((item) => [item.id, item]));
  (extra || []).forEach((item) => {
    if (!item?.id) return;
    byId.set(item.id, mergeNsmpResumoIntoRow(byId.get(item.id) || { id: item.id }, item));
  });
  return Array.from(byId.values());
};

export const mergeParticipacaoContext = (base, participacao) => {
  if (!participacao) return base;
  return {
    ...base,
    participacaoUsuario: {
      ...base?.participacaoUsuario,
      ...participacao.participacaoUsuario,
    },
    resumoNsirDigitacao: {
      ...base?.resumoNsirDigitacao,
      ...participacao.resumoNsirDigitacao,
    },
    nsmpResumos: mergeNsmpResumosArrays(base?.nsmpResumos, participacao?.nsmpResumos),
  };
};

export default mergeNsmpResumos;
